import { useEffect } from 'react'

import { AUTH_MODAL_EVENT, MODE } from 'Pods/LazyLoaded/AiSignInModal/constants'
import { openSignInModal } from 'Pods/ThreeDStudio/Store/actions/ui'

// Bridges the header Log in / Sign up buttons (rendered in a separate
// UnifiedNavigation React tree) to the in-page modal. On /ai those buttons
// publish AUTH_MODAL_EVENT instead of opening their own popover.
function useAuthModalTrigger() {
  useEffect(() => {
    if (typeof App === 'undefined' || !App.events) return undefined

    const handleOpen = (payload) => {
      const mode = payload?.mode === MODE.LOGIN ? MODE.LOGIN : MODE.SIGNUP
      openSignInModal(mode)
    }

    App.events.subscribe(AUTH_MODAL_EVENT, handleOpen)

    return () => {
      const unsub = App.events.unsubscribe || App.events.remove
      unsub?.call(App.events, AUTH_MODAL_EVENT, handleOpen)
    }
  }, [])
}

export default useAuthModalTrigger
